import { render, staticRenderFns } from "./skeleton-box.vue?vue&type=template&id=81b932fe&scoped=true&"
import script from "./skeleton-box.ts?vue&type=script&lang=ts&"
export * from "./skeleton-box.ts?vue&type=script&lang=ts&"
import style0 from "./skeleton-box.scss?vue&type=style&index=0&id=81b932fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b932fe",
  null
  
)

export default component.exports